/**
 * Vector twin of the sprite-pool gear texture. Used when a gear leaves the
 * board (pried loose, carried, thrown) so it keeps the exact silhouette and
 * size it had in its slot — a smaller or differently-toothed stand-in reads
 * as a different object and breaks the "that gear just got taken" read.
 */

import type { Graphics } from 'pixi.js';

const GEAR_TEETH = 8;

/** Draw a board-style gear centered on the Graphics origin. */
export function drawGearGraphic(gfx: Graphics, radius: number, color: number): void {
  const outerR = radius;
  const innerR = radius * 0.78;
  const toothHalfAngle = Math.PI / (GEAR_TEETH * 2.5);

  gfx.clear();
  gfx.moveTo(Math.cos(-toothHalfAngle) * outerR, Math.sin(-toothHalfAngle) * outerR);
  for (let i = 0; i < GEAR_TEETH; i++) {
    const base = (i / GEAR_TEETH) * Math.PI * 2;
    const next = ((i + 1) / GEAR_TEETH) * Math.PI * 2;
    const a2 = base + toothHalfAngle;
    const a4 = next - toothHalfAngle;
    gfx.lineTo(Math.cos(a2) * outerR, Math.sin(a2) * outerR);
    gfx.lineTo(Math.cos(a2) * innerR, Math.sin(a2) * innerR);
    gfx.lineTo(Math.cos(a4) * innerR, Math.sin(a4) * innerR);
    gfx.lineTo(Math.cos(a4) * outerR, Math.sin(a4) * outerR);
  }
  gfx.closePath();
  gfx.fill({ color });

  // Hub shading + axle hole, matching the texture's depth cues.
  gfx.circle(0, 0, radius * 0.38);
  gfx.fill({ color: 0x000000, alpha: 0.12 });
  gfx.circle(0, 0, radius * 0.15);
  gfx.fill({ color: 0x000000, alpha: 0.25 });
}
